module.exports = {"431227101":"波洲镇","431227103":"鱼市镇","431227104":"凉伞镇","431227105":"扶罗镇","431227106":"中寨镇","431227107":"晃洲镇","431227108":"林冲镇","431227109":"贡溪镇","431227110":"禾滩镇","431227200":"步头降苗族乡","431227215":"米贝苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431227.json
// module id = 1924
// module chunks = 0